$('.block-image-gallery-slider').each(function() {

	const slider = $(this);

    var thumbnails = new Swiper($(this).find('.thumbnail-slider')[0], {
		loop: true,
        slidesPerGroup: 1,
        slidesPerView: 4,
        spaceBetween: 4,
		speed: 500,
        watchSlidesProgress: true,
        breakpoints: {
            640: {
                spaceBetween: 8,
            },
        },
    });

    var gallery = new Swiper($(this).find('.gallery-slider')[0], {
		loop: true,
        navigation: {
			nextEl: slider.find('.swiper-arrow.next')[0],
			prevEl: slider.find('.swiper-arrow.prev')[0],
		},
        spaceBetween: 20,
		speed: 500,
        thumbs: {
            swiper: thumbnails,
        },

    });

    gallery.on('slideChange', function() {
        thumbnails.slideToLoop(gallery.realIndex);
    });

});
